module.exports = __webpack_public_path__ + "static/banner-mobile-service-f61344362b813e49ccfe1b2df1f59822.png";